import { gql } from 'apollo-angular';

export const CITADEL_ENVIRONMENT_INFO_FRAGMENT = gql`
  fragment CitadelEnvironmentInfo on CitadelEnvironment {
    environment_id
    name
  }
`;
